import { usePercentageBarGridlineStyles } from './percentage-bar-gridline.styles';

export function PercentageBarGridline({ color, percentage }: { color?: string; percentage: number }) {
  const classes = usePercentageBarGridlineStyles({ color, percentage });
  return (
    <div className={classes.root}>
      <div className={classes.bar}></div>
    </div>
  );
}
